import React, { memo, useMemo } from "react";
import Tree from "@components/ui/Tree";
import { useAppConfigStore } from "@shared/stores/appConfigStore";

type Props = {
  iShowFooter?: boolean;
  locationSelected?: number[];
  onClose?: () => void;
  onClear?: (id?: number) => void;
  onApply?: (selectedIds: number[], placeHolder?: string) => void;
  isShowClearButton?: boolean;
  isStartPage?: boolean;
};
const SelectLocationForm = ({
  iShowFooter = true,
  locationSelected,
  onClose,
  onClear,
  onApply,
  isShowClearButton = true,
  isStartPage = false,
}: Props) => {
  const { locationTree } = useAppConfigStore();
  const { parameters } = useAppConfigStore();
  const isEnableLocationCheckbox = useMemo(() => parameters.isEnableLocationCheckbox, [parameters]);
  const isSingleSelect = useMemo(() => {
    if (isStartPage) {
      return true
    }
    return !isEnableLocationCheckbox
  }, [isStartPage, isEnableLocationCheckbox]);

  return (
    <Tree
      className="w-full"
      nodeTree={locationTree}
      iShowFooter={iShowFooter}
      selected={locationSelected}
      maxHeight={300}
      onClose={onClose}
      isSingleSelect={isSingleSelect}
      onClear={onClear}
      isShowClearButton={isShowClearButton}
      onApply={onApply}
      isLocationTree={true}
    />
  );
};

export default memo(SelectLocationForm);
